//Componentes generales
import React, { useState, useContext } from "react";
import SearchInput from "../searchInput/SearchInput";
import RenderRow from "../renderRows/RRWarehouses";
import windowSizeContext from "../../context/windowSize/windowSizeContext";

//Estilos
import './WarehouseList.css';

/*
    Componente encargado de la vista de los depósitos disponibles.
    Donde warehousesWithSectors es la lista de depósitos con sus sectores anidados.
*/
function WarehouseList({ warehousesWithSectors = [] }) {

    const [filter, setFilter] = useState("");

    const wSizeContext = useContext(windowSizeContext);
    const { height } = wSizeContext;

    const handdlerSearchInput = (data) => {
        setFilter(data);
    };

    return (
        <div>
            <div style={{ marginLeft: "-150px" }}>
                <SearchInput defaultValue={filter} buscar={handdlerSearchInput} />
            </div>
            <div className='warehousesListDiv' style={{ height: height - 200, overflowY: 'scroll' }}>
                {
                    warehousesWithSectors
                        .filter(w =>
                            w.deposi.toLowerCase().includes(filter.toLowerCase()) ||
                            w.descrp.toLowerCase().includes(filter.toLowerCase()) ||
                            w.direcc.toLowerCase().includes(filter.toLowerCase())
                        )
                        .map((w, index) => (
                            <RenderRow
                                key={index}
                                index={index}
                                style={{}}
                                warehousesWithSectors={warehousesWithSectors}
                                filter={filter}
                            />
                        ))
                }
            </div>
        </div>
    );
}

export default WarehouseList;
